<template>
  <div class="navbar-filters-part">
    <CasesFilters v-if="casesRouteNames.indexOf($route.name) != -1" />
    <OrdersFilters v-if="orderRouteNames.indexOf($route.name) != -1" />
    <PhysicianFilters v-if="physicianRouteNames.indexOf($route.name) != -1" />
    <HospitalFilters v-if="hospitalRouteNames.indexOf($route.name) != -1" />
    <SendOutsFilters v-if="sendOutRouteNames.indexOf($route.name) != -1" />
    <UserAccountsFilters
      v-if="userAccountRouteNames.indexOf($route.name) != -1"
    />
    <BilledFilters v-if="billedRouteNames.indexOf($route.name) != -1" />
    <BillingRuleBookFilter
      v-if="billingRuleBookRouteNames.indexOf($route.name) != -1"
    />
  </div>
</template>

<script>
import CasesFilters from "@/components/navbarFilter/CaseFilter";
import OrdersFilters from "@/components/navbarFilter/OrderFilter";
import PhysicianFilters from "@/components/navbarFilter/PhysicianFilter";
import HospitalFilters from "@/components/navbarFilter/HospitalFilter";
import SendOutsFilters from "@/components/navbarFilter/SendOutsFilter";
import UserAccountsFilters from "@/components/navbarFilter/UserAccountsFilter";
import BilledFilters from "@/components/navbarFilter/BilledFilter";
import BillingRuleBookFilter from "@/components/navbarFilter/BillingRuleBookFilter";
export default {
  components: {
    CasesFilters,
    OrdersFilters,
    PhysicianFilters,
    HospitalFilters,
    SendOutsFilters,
    UserAccountsFilters,
    BilledFilters,
    BillingRuleBookFilter
  },
  data() {
    return {
      casesRouteNames: [
        "AllCases",
        "CaseView",
        "ActiveCases",
        "PendingCases",
        "CompleteCases",
        "ArchiveCase",
        "Case-Information-Update",
        "Concurrent-Case-Information-Update",
        "NewReportCases",
        "EMRNotSend",
        "CriticalCases",
        "PendingCasesList",
        "RejectedCases",
        "ReleasePending",
        "ReplacedInsurance",
        "RequiresAttentionCases",
      ],
      orderRouteNames: [
        "AllOrders",
        "ActiveOrders",
        "CompleteOrders",
      ],
      physicianRouteNames: [
        "AllPhysicians",
        "ActivePhysicians",
        "InActivePhysicians",
      ],
      hospitalRouteNames: [
        "AllHospitals",
        "ActiveHospitals",
        "InActiveHospitals",
        "Hospital-Primary-Information",
        "Branches-List",
        "HospitalPhysicians",
        "HospitalAccountManagers",
        "HospitalAdmins",
        "Add-Branch",
        "EditAccountManager",
        "EditHospitalAdmin",
        "Edit-Branch",
        "EditHospitalPhysician",
      ],
      userAccountRouteNames: [
        "userAccounts",
        "ActiveUserAccounts",
        "InActiveUserAccounts",
        "addUser",
        "EditUserAccount",
      ],
      sendOutRouteNames: [
        "allSendOuts",
        "ActiveSendOuts",
        "CompleteSendOuts",
        "SendoutsInformation",
        "SendOutsView",
      ],
      
      billedRouteNames: [
        "AllPendingBilledCases",
        "BilledCases",
        "ClientBilledCases",
        "ExceptionBilledCases",
        "OnholdBilledCases",
        "BilledExceptionBilledCases",
        "BilledPatientBilledCases",
        "CodingCases",
        "ExceptionResolvedCases",
        "ExceptionReviewedCases",
      ],
      billingRuleBookRouteNames: [
        "AllCodingRules",
        "AllClaim",
        "AllARRules",
        "PaymentRules",
        "PatientRules",
        "AddRules",
        "UpdatedRules",
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.navbar-filters-part {
  .filters-list {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    margin-top: 0 !important;

    li {
      z-index: 999;

      &:not(:last-child) {
        margin-right: 5px;
        @media (min-width: 1200px) and (max-width: 1400px) {
          margin-right: 0;
        }
      }
    }
    a {
      color: #888383;
      font-weight: 500;
      font-size: 13px;
      display: block;
      padding: 5px 7px;

      transition: all 0.2s ease-in-out;
      &:hover {
        color: #273480;
      }
      @media (min-width: 1200px) and (max-width: 1400px) {
        font-size: 13px;
        padding: 5px 8px;
      }
    }
    .active-icon {
      display: none;
    }

    // router-link-active
    .router-link-active,
    .router-link-active-parent > a {
      position: relative;
      color: #273480;
      opacity: 1;
      font-weight: 500;
      z-index: 1;
      .active-icon {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        transform: translateX(40%);
        transition: all 5s ease;
        z-index: -1;
        img {
          margin-bottom: -13px;
        }
        img:first-child {
          margin-left: -2px;
        }
      }
    }
  }
}
</style>
